// Watchlist Bid Bot — per-auction chip ceiling. Whenever we detect an outbid
// on an auction that has an active bidbot, we auto-place the minimum
// increment (until the ceiling would be exceeded).
//
// Storage: ppe_bidbot_v1 = { auctionId: ceiling }
const KEY = "ppe_bidbot_v1";

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}") || {}; }
  catch { return {}; }
}
function write(v) { localStorage.setItem(KEY, JSON.stringify(v)); }

export function getBidbotCeiling(auctionId) {
  return Number(read()[auctionId] || 0) || 0;
}

export function setBidbotCeiling(auctionId, ceiling) {
  const v = read();
  const cap = Math.max(0, Math.floor(ceiling));
  if (cap <= 0) delete v[auctionId];
  else v[auctionId] = cap;
  write(v);
}

export function getAllBidbots() { return read(); }

/** Given the fetched open auctions and cached bidbot ceilings, return any
 *  auction where the current top_bid < ceiling AND we are NOT the top bidder. */
export function nextAutoBidTargets(auctions, myEmail, myHandleLower) {
  const bots = read();
  const out = [];
  for (const a of auctions || []) {
    const cap = Number(bots[a.id] || 0) || 0;
    if (cap <= 0) continue;
    const minNext = Math.max(a.start_bid || 0, (a.top_bid || 0) + 1);
    if (minNext > cap) continue;
    // Skip if we're the top bidder already (best-effort — server checks by email;
    // we approximate by comparing masked seller_handle when available)
    const sh = String(a.seller_handle || "").toLowerCase();
    if (myHandleLower && sh.includes(myHandleLower)) continue;
    out.push({ auction: a, minNext });
  }
  return out;
}
